import { render, staticRenderFns } from "./Homework.vue?vue&type=template&id=620dcffe&scoped=true"
import script from "./Homework.vue?vue&type=script&lang=ts"
export * from "./Homework.vue?vue&type=script&lang=ts"
import style0 from "./Homework.vue?vue&type=style&index=0&id=620dcffe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620dcffe",
  null
  
)

export default component.exports